import { render } from "./TableHeaderItem.vue?vue&type=template&id=1364e6c1"
import script from "./TableHeaderItem.vue?vue&type=script&lang=js"
export * from "./TableHeaderItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/tchery/dev/assiette-parfaite/frontend-gesit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__